import { call, take, takeEvery } from 'redux-saga/effects';

import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';

import { transformResponseToGoals, transformGoalToRequestData } from './transformers';


// ===============================================================================================
// SAGAS functions for goals.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) => mkQcsSyncResourceConfig({
  resourceName: 'goal',
  resourceBaseUrl: '/goals',
  getLastSyncDate,

  transformResponseToResources: transformResponseToGoals,
  transformResourceToRequestData: transformGoalToRequestData,
  // transformResourcesToRequestData: transformGoalsToRequestData,

  successAction,
  failureAction,
});

export function* getGoalsActionWatcher() {
  // using a vanilla saga pattern so we only process a single get request
  //   - takeEvery would process every request
  //   - takeLatest would cancel any current request and start request again
  while (true) {
    const action = yield take(actions.getGoals);

    const config = mkResourceConfig(actions.getGoalsSuccess, actions.getGoalsFailure);
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createGoalActionWatcher() {
  const config = mkResourceConfig(actions.createGoalSuccess, actions.createGoalFailure);
  yield takeEvery(actions.createGoal, qcsSyncCreateResource, config);
}

export function* updateGoalActionWatcher() {
  const config = mkResourceConfig(actions.updateGoalSuccess, actions.updateGoalFailure);
  yield takeEvery(actions.updateGoal, qcsSyncUpdateResource, config);
}

export function* deleteGoalActionWatcher() {
  const config = mkResourceConfig(actions.deleteGoalSuccess, actions.deleteGoalFailure);
  yield takeEvery(actions.deleteGoal, qcsSyncDeleteResource, config);
}

// ====================================================
// EXPORTS

export default [
  getGoalsActionWatcher,
  createGoalActionWatcher,
  updateGoalActionWatcher,
  deleteGoalActionWatcher,
];
